import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import Client1 from '../Assets/img/partners/LSE-Economics-Political-Science-Logo_SNWKidB.png';
import Client2 from '../Assets/img/partners/Uni-logo-Stirling.jpg';
import Client3 from '../Assets/img/partners/UoH-1500x900-1.jpg';
import Client4 from '../Assets/img/partners/download (1).jpg';
import Client5 from '../Assets/img/partners/download.jpg';
import Client6 from '../Assets/img/partners/images.jpg';
import Client7 from '../Assets/img/partners/Yoast-social-logo.jpg';
import BackgroundImage from '../Assets/img/blog/freepik__candid-image-photography-natural-textures-highly-r__73741.jpeg';

// Styled components for the clients slider section
const ClientsSection = styled.div`
//   background: url(${BackgroundImage}) no-repeat center center/cover; /* Full-screen background image */
  position: relative;
  padding: 60px 0;
  text-align: center;
  color: #fff;
  overflow: hidden;
`;

// const TransparentOverlay = styled.div`
//   background: rgba(0, 0, 0, 0.6); /* Semi-transparent overlay */
//   padding: 40px;
//   border-radius: 12px;
//   margin: 0 auto;
//   width: 90%;
//   max-width: 1200px;
//   box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3); /* Soft shadow for depth */
// `;

const SliderContainer = styled.div`
  position: relative;
`;

const ClientImage = styled.img`
  max-height: 90px;
  margin: 0 15px;
  border-radius: 12px;
//   filter: grayscale(100%);
  transition: all 0.4s ease;

  &:hover {
    filter: grayscale(0%);
    transform: scale(1.15);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  }
`;

const SectionTitle = styled.h2`
  flex: 1;
  font-size: 1.5rem;
  font-weight: 800;
  text-align: center;  /* Corrected property */
  color: #333333;
  margin-bottom: 1rem;
  text-transform: capitalize;
  letter-spacing: px;
`;


const Clients = () => {
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <ClientsSection>
      {/* <TransparentOverlay> */}
         <SectionTitle><h2>Awards, affiliation of our mentees</h2>
         </SectionTitle> 
        <SliderContainer>
          <Slider {...sliderSettings}>
            <div>
              <ClientImage src={Client1} alt="Client 1" />
            </div>
            <div>
              <ClientImage src={Client2} alt="Client 2" />
            </div>
            
            <div>
              <ClientImage src={Client3} alt="Client 3" />
            </div>
            <div>
              <ClientImage src={Client4} alt="Client 4" />
            </div>
            <div>
              <ClientImage src={Client5} alt="Client 5" />
            </div>
            <div>
              <ClientImage src={Client6} alt="Client 6" />
            </div>
            <div>
              <ClientImage src={Client7} alt="Client 7" />
            </div>
          </Slider>
        </SliderContainer>
      {/* </TransparentOverlay> */}
    </ClientsSection>
  );
};

export default Clients;
